//Componentes generales
import { useEffect, useContext, useRef } from 'react';
import ReqList from '../../components/ReqList/ReqList';

//Estilos
import './Home.css';

//Contexto
import controlGLBContext from '../../context/controlGLB/controlGLBContext';
import controlContext from '../../context/control/controlContext';
import authContext from '../../context/authentication/authContex';
import usuariosContext from '../../context/usuarios/usuariosContext';
import sectoresReqsContext from '../../context/sectoresReqs/reqsSectorsContext';
import agregarReqContext from '../../context/agregarReq/agregarReqContext';

import clienteAxios from '../../config/axios';

// Alertas
import Swal from 'sweetalert2';
import { useState } from 'react';

/* 
  Vista donde se gestiona toda la lógica de listado de requerimientos. Es la vista principal de toda la aplicación.
  Donde props no se encuentra en uso.
*/
function Home(props) {
  //Context auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context usuarios
  const uContext = useContext(usuariosContext);
  const { userList, userListView, actualizarUserListView, userVisualiza } =
    uContext;

  //Context sectores de requerimientos
  const sRContext = useContext(sectoresReqsContext);
  const { reqsSectorsList, actualizarReqsSectorsList } = sRContext;

  //Context control requerimientos
  const cContext = useContext(controlContext);
  const {
    listTDoc,
    filtrosRango,
    filtrosEstado,
    iniciarFiltrosIsLoading,
    activeWorkSpace,
    modificarFiltrosEstado,
    modificarFiltrosRango,
    getProductsByNroFor,
    filtrar,
  } = cContext;

  //Contexto general generación de informe
  const GLBContext = useContext(controlGLBContext);
  const {
    generarInformeReqPDF,
    modificarEstado,
    getFilesByTDoc,
    enviarReqApi,
  } = GLBContext;

  //Context Edit Requerimiento
  const addContext = useContext(agregarReqContext);
  const { guardarRequerimiento, editarRequerimientoBE } = addContext;

  const [listTDocHome, setListTDocHome] = useState(listTDoc ? listTDoc : []);

  //state de cantidad de requerimientos en estado PENDIENTE
  const [countPendientes, setCountPendientes] = useState(0);

  // Ref para detectar cuándo iniciarFiltros acaba de completarse (transición true → false)
  const prevIniciarFiltrosIsLoading = useRef(false);

  /* 
    Disparador que actualiza la lista de usuarios disponibles, sectores de requerimientos,
    solicitantes y responsables al momento de renderizar el componente.
  */
  useEffect(() => {
    if (usuario) {
      const fn = async () => {
        await actualizarUserListView(usuario);
        await actualizarReqsSectorsList();
      };
      fn();
    }
  }, []);

  useEffect(() => {
    // Evitar el cálculo mientras los filtros están siendo reiniciados para evitar parpadeo
    if (iniciarFiltrosIsLoading) return;

    if (listTDoc) {
      // Aplicar filtros de estado
      let listaFiltrada = filtrar(listTDoc, filtrosEstado);

      // Aplicar filtros de rango (fechas) solo si existen
      if (filtrosRango) {
        listaFiltrada = listaFiltrada.filter(r => {
          const fchMov = new Date(r.fchMov);
          const hayFiltroDesde = filtrosRango.fchMov?.desde;
          const hayFiltroHasta = filtrosRango.fchMov?.hasta;
          const hayFiltroDelivery = filtrosRango.deliveryDate;

          // Filtro por fecha desde (solo si existe)
          if (hayFiltroDesde && fchMov < new Date(hayFiltroDesde)) return false;

          // Filtro por fecha hasta (solo si existe)
          if (hayFiltroHasta && fchMov > new Date(hayFiltroHasta)) return false;

          // Filtro por fecha de entrega (solo si existe)
          if (
            hayFiltroDelivery &&
            new Date(r.deliveryDate) > new Date(hayFiltroDelivery)
          )
            return false;

          return true;
        });
      }

      setListTDocHome(listaFiltrada);
    }
  }, [listTDoc, filtrosEstado, filtrosRango, iniciarFiltrosIsLoading]);

  useEffect(() => {
    // Evitar el cálculo mientras los filtros están siendo reiniciados para evitar parpadeo
    if (iniciarFiltrosIsLoading) {
      prevIniciarFiltrosIsLoading.current = true;
      return;
    }

    if (listTDoc) {
      // Solo aplicar filtros  y actualizar countPendientes si estamos en el workspace PENDIENTES
      if (activeWorkSpace.pendientes === 1) {
        // Aplicar filtros de estado (usuario, sector, prioridad)
        let listaFiltrada = filtrar(listTDoc, filtrosEstado);

        // Aplicar filtros de rango (fechas) solo si existen
        if (filtrosRango) {
          listaFiltrada = listaFiltrada.filter(r => {
            const fchMov = new Date(r.fchMov);
            const hayFiltroDesde = filtrosRango.fchMov?.desde;
            const hayFiltroHasta = filtrosRango.fchMov?.hasta;
            const hayFiltroDelivery = filtrosRango.deliveryDate;

            // Filtro por fecha desde (solo si existe)
            if (hayFiltroDesde && fchMov < new Date(hayFiltroDesde))
              return false;

            // Filtro por fecha hasta (solo si existe)
            if (hayFiltroHasta && fchMov > new Date(hayFiltroHasta))
              return false;

            // Filtro por fecha de entrega (solo si existe)
            if (
              hayFiltroDelivery &&
              new Date(r.deliveryDate) > new Date(hayFiltroDelivery)
            )
              return false;

            return true;
          });
        }

        const pendientesFiltrados = listaFiltrada.filter(
          r => r.state === 'PENDIENTE'
        );
        setCountPendientes(pendientesFiltrados.length);
      } else {
        // Si NO estamos en PENDIENTES, solo actualizar cuando iniciarFiltros acaba de completarse.
        // Así los filtros (rango, estado) no modifican el contador al estar en otro workspace.
        if (prevIniciarFiltrosIsLoading.current) {
          const pendientesTotal = listTDoc.filter(r => r.state === 'PENDIENTE');
          setCountPendientes(pendientesTotal.length);
        }
      }
    }

    prevIniciarFiltrosIsLoading.current = false;
  }, [
    listTDoc,
    filtrosEstado,
    filtrosRango,
    iniciarFiltrosIsLoading,
    activeWorkSpace,
  ]);

  useEffect(() => {
    if (usuario) {
      const fn = async () => {
        await actualizarUserListView(usuario);
        console.log('Se actualizó el userListView');
      };
      fn();
    }
  }, [userList]);

  /* 
    Manejador que comprueba los permisos que posee el usuario en sesión para un rol enviado por parametro.
    Donde roles_autorizados es el rol a comprobar.
    Retorna true si esta autorizado, false si no.
  */
  const handleCheckPermisos = roles_autorizados => {
    let autoriza = false;
    for (const element of roles_autorizados) {
      if (usuario.userType.some(item => item.typeName === element)) {
        autoriza = true;
      }
    }
    return autoriza;
  };

  /* 
    Manejador para la modificación rapida de un requerimiento. Se utiliza en 3 ocaciones, edición del estado de autorización, notas privadas y notas publicas.
    Donde reqe es el requerimiento a actualizar.
    upd es lo modificado.
  */
  const handleModifyStateReq = async (reqe, upd) => {
    const resp = await modificarEstado(reqe, usuario, upd);
    return resp;
  };

  /* 
    Manejador que recupera todos los items de un requerimiento dado por parametro.
    Donde tDocCodFor es el Codfor del requerimiento (normalmente REQ).
    tDocNrofor es el Nrofor del requerimiento.
  */
  const handlerVerReqDetails = async (tDocCodFor, tDocNroFor) => {
    return await getProductsByNroFor(tDocCodFor, tDocNroFor);
  };

  /* 
    Manejador que recupera los archivos adjuntados a un requerimiento especificado por parámetro.
    Donde "req" es el requerimiento de donde recuperar los archivos.
  */
  const handlerRecuperaFiles = async (req, type) => {
    const files = await getFilesByTDoc(req, type);
    return files
      ? files.map(f => {
          return {
            name: f.fileName === undefined ? f.name : f.fileName,
            url: f.url,
          };
        })
      : [];
  };

  /* 
    Manejador encargado de generar un archivo pdf con formato brindado en el back-end. Se descarga automaticamente y se abre en una nueva pestaña.
    Donde doc es el archivo a generar.
    user es el usuario en sesión que llama a la función.
  */
  const handlerGeneraPDF = async (doc, visualizaPrecioProduct) => {
    await generarInformeReqPDF(doc, visualizaPrecioProduct);
  };

  /* 
    Función encargada de aplicar y/o inicializar los filtros.
    Donde filtrosProp son los filtros a aplicar.
    signal no se encuentra actualmente en uso.
    El parametro recibido es un objeto que contiene los filtros de estado y de rango, se aplican cada uno con su respectiva función.
  */
  const apFiltros = async filtrosProp => {
    await modificarFiltrosEstado(filtrosProp.filterEstado);
    await modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
  };

  /* 
    Función encargada de validar los campos del requerimiento a guardar. Valida que este ingresado el titulo, que no existan items sin cantidad y que por lo menos contenga un item con cantidad.
    Donde r es el requerimiento a validar.
    i son los items del requerimiento a validar.
    Se llama al momento de guardar.
  */
  const validacionesCampos = (r, i) => {
    let resp = '';
    if (r.title === '') {
      resp = 'Falta ingresar titulo de requerimiento';
    } else {
      if (i.length === 0) {
        resp = 'Ingrese por lo menos un item';
      } else {
        let control = 0;
        for (const element of i) {
          if (element.quantity === 0) {
            control = 1;
          }
          if (!element.tipoCosto) {
            resp = 'Debe seleccionar un tipo de costo para cada item';
            return resp;
          }
        }
        if (control === 1) {
          resp = 'Existe un item sin cantidad asignada';
        }
      }
    }
    return resp;
  };

  /* 
    Manejador encargado de guardar un nuevo requerimiento. Realiza validaciones y si no la supera no se guarda el requerimiento.    
    Donde requeriment es el requerimiento a guardar.
    items son los items del requerimiento.
    files son los archivos adjuntos del requerimiento.
  */
  const handleSaveReq = async (requeriment, items, files, accountingProration = [], clientProration = []) => {
    const msj = validacionesCampos(requeriment, items);

    if (requeriment !== undefined && requeriment !== null) {
      if (msj === '') {
        try {
          const resp = await guardarRequerimiento(
            requeriment,
            items,
            usuario,
            files,
            accountingProration,
            clientProration
          );
          Swal.fire({
            title: `Se guardo un nuevo requerimiento`,
            icon: 'success',
            text: `El numero de requerimiento es : ${resp.tDocNroFor}`,
            showConfirmButton: true,
            allowEnterKey: true,
          });
          return resp;
        } catch (error) {
          console.error('Error al repetir requerimiento:', error);
          console.error('Respuesta del servidor:', error.response?.data);
          Swal.fire({
            title: 'Error al repetir el requerimiento',
            icon: 'error',
            text:
              error.response?.data?.message ||
              'Ocurrió un error inesperado (código ' +
                error.response?.status +
                ')',
            showConfirmButton: true,
          });
        }
      } else {
        Swal.fire({
          title: msj,
          icon: 'warning',
          showConfirmButton: true,
          allowEnterKey: true,
        });
      }
    }
  };

  /* 
    Manejador que controla el evento ante un click en el boton editar, recuperando los items y archivos adjuntos del requerimiento para comenzar la edición.
    Donde req es el requerimiento a editar. 
  */
  const handdleEditClick = async req => {
    try {
      const items = await getProductsByNroFor(req.tDocCodFor, req.tDocNroFor);
      const files = (await getFilesByTDoc(req, 'adjunto')).map(f => {
        return {
          name: f.fileName === undefined ? f.name : f.fileName,
          url: f.url,
        };
      });
      return { items, files };
    } catch (error) {
      console.log('error');
      return null;
    }
  };

  /* 
    Manejador encargado de guardar los cambios realizados en la edición de un requerimiento. Realiza validaciones y si no la supera no se guarda las modificaciones del requerimiento.  
    Donde requeriment es el requerimiento a guardar.
    items son los items del requerimiento.
    files son los archivos adjuntos del requerimiento.
    fileBase son los archivos originales antes de la edición.
  */
  const handdleEdit = async (requeriment, items, files, fileBase, accountingProration = [], clientProration = []) => {
    const msj = validacionesCampos(requeriment, items);

    if (requeriment !== undefined && requeriment !== null) {
      if (msj === '') {
        try {
          const resp = await editarRequerimientoBE(
            requeriment,
            items,
            files,
            fileBase,
            usuario,
            accountingProration,
            clientProration
          );
          Swal.fire({
            title: `Se modifico el requerimiento`,
            icon: 'success',
            text: `El numero de requerimiento modificado es : ${requeriment.tDocNroFor}`,
            showConfirmButton: true,
            allowEnterKey: true,
          });
          return resp;
        } catch (error) {
          console.error('Error al editar requerimiento:', error);
          console.error('Respuesta del servidor:', error);
          Swal.fire({
            title: 'Error al modificar el requerimiento',
            icon: 'error',
            text:
              error.response?.data?.message ||
              error.response?.message ||
              'Ocurrió un error inesperado',
            showConfirmButton: true,
          });
        }
      } else {
        Swal.fire({
          title: msj,
          icon: 'warning',
          showConfirmButton: true,
          allowEnterKey: true,
        });
      }
    }
  };

  /* 
    Manejador encargado de enviar el requerimiento a Softland mediante llamada a rutas del webService.
    Donde data es el requerimiento a enviar.
  */
  const handdleEnviaApi = async data => {
    try {
      await enviarReqApi(data);
      Swal.fire({
        title: `Enviado`,
        icon: 'success',
        text: `Requerimiento ${data.tDocCodFor}-${data.tDocNroFor} enviado correctamente`,
        showConfirmButton: true,
        allowEnterKey: true,
      });
    } catch (err) {
      console.log('Error en enviar a Servidor');
      Swal.fire({
        title:
          err.message ||
          'El Estado no fue Enviado. Por favor, vuelve a intentarlo más tarde. ',
        icon: 'error',
        showConfirmButton: true,
        allowEnterKey: true,
      });
    }
  };

  return (
    <div className="container-list">
      <ReqList
        currentUser={usuario}
        userListView={userListView}
        reqsSectorsList={reqsSectorsList}
        listTDoc={listTDocHome}
        modificarEstado={handleModifyStateReq}
        verDetalle={handlerVerReqDetails}
        recuperaFilesDetalle={handlerRecuperaFiles}
        filtros={{ filtrosRango, filtrosEstado }}
        aplicarFiltros={apFiltros}
        generaPDF={handlerGeneraPDF}
        checkPermisos={handleCheckPermisos}
        guardarComo={handleSaveReq}
        eventoClickEdicion={handdleEditClick}
        editar={handdleEdit}
        sendToAPI={handdleEnviaApi}
        countPendientes={countPendientes}
      />
    </div>
  );
}

export default Home;